package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.faq.FaqClosingSection
import com.anjuros.website.redesign.sections.faq.FaqHeroSection
import com.anjuros.website.redesign.sections.faq.FaqTopicsSection
import com.anjuros.website.redesign.sections.faq.faqStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun FAQ() {
    val title = LocalText(RdText.FAQS_META_TITLE)
    val description = LocalText(RdText.FAQS_META_DESCRIPTION)
    val structuredData = faqStructuredData()
    var query by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.FAQ}")
        setJsonLd("ld-faq", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.FAQ))
        Main {
            FaqHeroSection(query, onQueryChange = { query = it })
            FaqTopicsSection(query)
            FaqClosingSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
